<template>
	<gc-dialog
		width="1120px"
		:show.sync="visible"
		title="选择站点"
		ok-text="确 定"
		:ok-loading="loading"
		:show-close="false"
		@open="handleOpen"
		@ok="handleConfirm"
		@cancel="handleClose"
		@close="handleClose"
	>
		<div class="station-dialog__body">
			<div class="station-list">
				<div class="station-filter">
					<gc-custom-search
						keyWord="调压器编号"
						width="320px"
						:search.sync="params.regulatorCode"
						@on-keyup-enter="handleSearch"
					/>
					<el-button type="primary" size="small" @click="handleSearch">查 询</el-button>
					<el-button size="small" @click="handleReset">重 置</el-button>
				</div>
				<gc-table
					ref="stationTable"
					v-loading="loading"
					height="380px"
					border
					showPage
					:columns="columns"
					:table-data="tableData"
					:total="total"
					:page-size="size"
					:current-page="current"
					:is-highlight-current="true"
					:total-hide="false"
					:row-class-name="getRowClassName"
					paginationLayout="prev, next, jumper"
					@row-click="handleRowClick"
					@size-change="handleSizeChange"
					@current-page-change="handlePageChange"
				></gc-table>
			</div>
			<div class="station-preview">
				<div class="station-preview__title">站点信息</div>
				<div class="station-preview__item">
					<span>调压器编号</span>
					<strong>{{ currentRow.regulatorCode || '--' }}</strong>
				</div>
				<div class="station-preview__item">
					<span>采集器编号</span>
					<strong>{{ currentRow.collectorDeviceNo || '--' }}</strong>
				</div>
				<div class="station-preview__item">
					<span>品牌/型号</span>
					<strong>{{ formatStationModel(currentRow) }}</strong>
				</div>
				<div class="station-preview__item">
					<span>调压柜/箱编号</span>
					<strong>{{ currentRow.cabinetNo || '--' }}</strong>
				</div>
				<div class="station-preview__item">
					<span>安装日期</span>
					<strong>{{ currentRow.installDate || '--' }}</strong>
				</div>
				<div class="station-preview__item station-preview__item--block">
					<span>安装地址</span>
					<strong>{{ currentRow.installAddress || '--' }}</strong>
				</div>
			</div>
		</div>
	</gc-dialog>
</template>

<script>
import { apiGetPressureRegulatorList } from '@/apis/pressureRegulatorManage.api'

export default {
	name: 'StationSelectDialog',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		selectedStation: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			loading: false,
			tableData: [],
			total: 0,
			current: 1,
			size: 8,
			currentRow: {},
			params: {
				regulatorCode: null,
			},
			columns: [
				{ key: 'regulatorCode', name: '调压器编号', minWidth: 160, tooltip: true },
				{ key: 'collectorDeviceNo', name: '采集器编号', minWidth: 150, tooltip: true },
				{ key: 'installAddress', name: '安装地址', minWidth: 240, tooltip: true },
				{ key: 'subDeviceCount', name: '子设备数', width: 90 },
			],
		}
	},
	computed: {
		visible: {
			get() {
				return this.show
			},
			set(val) {
				this.$emit('update:show', val)
			},
		},
	},
	methods: {
		handleOpen() {
			this.currentRow = { ...this.selectedStation }
			this.getList(1)
		},
		handleClose() {
			this.visible = false
		},
		getRequestParams() {
			const params = {
				current: this.current,
				size: this.size,
			}
			Object.keys(this.params).forEach(key => {
				const value = this.params[key]
				if (value !== null && value !== undefined && value !== '') {
					params[key] = value
				}
			})
			return params
		},
		async getList(current = this.current) {
			this.current = current
			this.loading = true
			try {
				const res = await apiGetPressureRegulatorList(this.getRequestParams())
				this.tableData = res.records || []
				this.total = res.total || 0
				this.current = res.current || current
				this.$nextTick(this.setCurrentTableRow)
			} catch (error) {
				this.tableData = []
				this.total = 0
			} finally {
				this.loading = false
			}
		},
		setCurrentTableRow() {
			const currentRow = this.tableData.find(item => item.collectorDeviceNo === this.currentRow.collectorDeviceNo)
			if (currentRow && this.$refs.stationTable) {
				this.$refs.stationTable.setCurrentRow(currentRow)
			}
		},
		handleSearch() {
			this.getList(1)
		},
		handleReset() {
			this.params.regulatorCode = null
			this.getList(1)
		},
		handlePageChange(current) {
			this.getList(current)
		},
		handleSizeChange(size) {
			this.size = size
			this.getList(1)
		},
		handleRowClick({ row }) {
			if (!row || !row.collectorDeviceNo) return
			this.currentRow = row
		},
		getRowClassName({ row }) {
			return row && row.collectorDeviceNo ? '' : 'is-disabled-row'
		},
		handleConfirm() {
			if (!this.currentRow.collectorDeviceNo) {
				return this.$message.warning('请选择已绑定采集器的站点')
			}
			this.$emit('select', this.currentRow)
			this.visible = false
		},
		formatStationModel(row = {}) {
			const texts = [row.brand, row.model].filter(Boolean)
			return texts.length ? texts.join(' / ') : '--'
		},
	},
}
</script>

<style lang="scss" scoped>
.station-dialog__body {
	display: grid;
	grid-template-columns: minmax(0, 1fr) 280px;
	gap: 16px;
	padding-bottom: 12px;
	height: 540px;
}

.station-list {
	min-width: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.station-filter {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 12px;
	flex-shrink: 0;
}

.station-list ::v-deep .gc-table {
	flex: 1;
	min-height: 0;
}

.station-list ::v-deep .is-disabled-row {
	color: #a8abb2;
	cursor: not-allowed;
	background: #fafafa;
}

.station-preview {
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	background: #fff;
	padding: 14px;
	align-self: stretch;
}

.station-preview__title {
	font-size: 15px;
	font-weight: 700;
	color: #0f172a;
	margin-bottom: 12px;
	padding-bottom: 10px;
	border-bottom: 1px solid #e2e8f0;
}

.station-preview__item {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	padding: 9px 0;
	border-bottom: 1px solid #f1f5f9;
	font-size: 13px;

	span {
		color: #64748b;
		flex-shrink: 0;
	}

	strong {
		color: #334155;
		font-weight: 600;
		text-align: right;
		word-break: break-all;
	}

	&--block {
		flex-direction: column;
		gap: 6px;

		strong {
			text-align: left;
			line-height: 1.5;
		}
	}
}
</style>
